<template>
  <el-container id="tab" class="ys-page">
    <!-- <el-aside :width="isCollapse ? '20px' : '300px'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>商品类别</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <cascader-multiple ref="cascaderMultiple" :args="cascaderArgs" :default-checked-keys="defaultCheckedKeys" :default-disabled-keys="defaultDisabledKeys" :from="{...queryItem, isCanEnter: $refs[activeName]?.$children[0].isCanEnter }" @get-product-data="getProductData"></cascader-multiple>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">商品</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">类别</span>
      </div>
    </el-aside> -->
    <el-main>
      <el-tabs type="border-card">
        <el-tab-pane ref="damage">
          <query-form @getQueryForm="getQueryForm" :billNo="billNo"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower"
            :power="{ tag, billNo, hideColumnList }"></orderEntering>
        </el-tab-pane>
        
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
// import cascaderMultiple from '@/components/invWare/invCheck/part/cascaderMultiple.vue'
import queryForm from '@/components/invWare/invCheck/part/queryForm.vue'
import orderEntering from '@/components/invWare/invCheck/part/orderEntering.vue'

export default {
  name: "Inventory",
  props: ['billNo', 'tag'],
  components: {
    queryForm,
    orderEntering,
    // cascaderMultiple
  },
  data() {
    let billType = 'PKD'
    return {
      isCollapse: false,
      billType,
      cascaderArgs: {
        billType: billType,
        searchType: 3
      },
      activeName: 'damage',
      queryItem: {
        billType: billType
      },
      hideColumnList: [
        {
          "label": "品牌",
          "prop": "itemBrandName"
        },
        {
          "label": "品类",
          "prop": "brandTypeName"
        },
        {
          "label": "账面数折算小单位",
          "prop": "onhandQty"
        },
        {
          "label": "订单占用量",
          "prop": "onLoadQtyFormat"
        },
        {
          "label": "可用量",
          "prop": "availableQtyFormat"
        },
        {
          "label": "盘点数折算小单位",
          "prop": "realQty"
        },
        {
          "label": "条码",
          "prop": "invBarCode"
        },
        {
          "label": "生产日期",
          "prop": "productionDate"
        }
      ],
      defaultCheckedKeys: [],
      defaultDisabledKeys: [],
      btnPower: {}
    }
  },
  created() {
    this.getCustomColumn()
    this.getBtnPower()
    if (this.billNo) {
      this.getEditTabledata()
    }
  },
  // mounted() {
  //   this.$watch(() => this.$refs[this.activeName]?.$children[0].selectProductList, (val) => {
  //     try {
  //       this.defaultCheckedKeys = [...val]
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   })
  // },
  methods: {
    async getBtnPower() {
      let menuID = 164
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectFunctionButtonAuth.html', this.Qs.stringify({ menuID }))
      res.result = JSON.parse(res.result)
      this.btnPower = JSON.parse(res.result.data)
      console.log(this.btnPower)
    },
    // 表单信息更改时触发，更新本组件的表单信息
    getQueryForm(e) {
      console.log(e)
      this.queryItem = { ...this.queryItem, ...e }
    },
    // 重置商品类别
    resetCascaderMultiple() {
      this.$refs['cascaderMultiple'].getBrandData()
    },
    // 品牌/类别盘点中左侧勾选时触发请求商品信息
    async getProductData({ checked, row, leaf }) {
      let $table = this.$refs[this.activeName]?.$children[1]
      $table.tableLoading = true
      let $queryForm = this.$refs[this.activeName]?.$children[0]
      if (checked) {
        $table.deleteProductToOrder(leaf ? 'itemTypeID' : 'financialBrandID', row.value)
        const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/invCheck/selectItemList', {
          billType: 'PKD',
          warehouseID: this.queryItem.warehouse.value || '',
          [leaf ? 'secondType' : 'firstType']: row.type,
          [leaf ? 'secondValue' : 'firstValue']: row.value,
          searchType: 3,
        })
        if (res.code != '0') {
          $table.tableLoading = false
          this.$message.error(res.message)
          return false
        }
        $queryForm.selectProductList = $queryForm.selectProductList.concat(res.data.itemSearchList)
        const result = await $table.addProductToOrder(res.data.itemSearchList)
        if (result) $table.tableLoading = false
      } else {
        $queryForm.selectProductList = $queryForm.selectProductList.filter(item => item[leaf ? 'itemTypeID' : 'financialBrandID'] != row.value)
        const res = await $table.deleteProductToOrder(leaf ? 'itemTypeID' : 'financialBrandID', row.value)
        if (res) $table.tableLoading = false
      }
    },
    // 复制或编辑，根据billNo获取单据详情
    getEditTabledata() {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        let $queryForm = this.$refs[this.activeName]?.$children[0]
        $queryForm.isCanEnter = true
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify({
          billType: this.billType,
          billNo: this.billNo
        }))
        let { headInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
        console.log({ headInfo, itemList });
        if (res.code != 'success') return this.$message.error(res.message)
        let inWarehouse = $queryForm.queryForm.inWarehouse.selected = { value: headInfo.warehouseID, text: headInfo.warehouseName }
        $queryForm.queryForm.inWarehouse.list = $queryForm.queryForm.inWarehouse.list.filter(item => item.value != inWarehouse.value)
        $queryForm.queryForm.inWarehouse.list.unshift(inWarehouse)

        // let salesman = $queryForm.queryForm.salesman.selected = { value: headInfo.salesmanID, text: headInfo.salesmanName }
        // $queryForm.queryForm.salesman.list = $queryForm.queryForm.salesman.list.filter(item => item.value != salesman.value)
        // $queryForm.queryForm.salesman.list.unshift(salesman)

        let deliverUser = $queryForm.queryForm.deliverUser.selected = { value: headInfo.checkUserID, text: headInfo.checkUserName }
        $queryForm.queryForm.deliverUser.list = $queryForm.queryForm.deliverUser.list.filter(item => item.value != deliverUser.value)
        $queryForm.queryForm.deliverUser.list.unshift(deliverUser)
        // $queryForm.inWarehouseSelect()

        $queryForm.selectProductList = itemList.map(item => {
          item.isLess = false
          if(Number(item.realQty || 0) < Number(item.onLoadQty || 0)) { //盘点数小于占用量不可录入
            item.isLess = true
          }
          return item
        })
        /**
         * 这里是禁止库存调整、库存报损删除的代码，仅仅限制了商品选择的dialog
         */
        // $queryForm.defaultDisabledKeys = itemList
        this.getQueryForm($queryForm.queryItem)
        $table.sum.invCheckLossAmt = Number(headInfo.invCheckLossAmt || 0)
        $table.sum.invCheckProfitAmt = Number(headInfo.invCheckProfitAmt || 0)
        $table.sum.totalAmt = Number(headInfo.totalAmt || 0)
        $table.sum.billInvQty = Number(headInfo.billInvQty || 0)
        $table.sum.billMedQty = Number(headInfo.billMedQty || 0)
        $table.sum.billSalQty = Number(headInfo.billSalQty || 0)

        $table.isMultiplePeople = headInfo.isMultiplePeople

        this.defaultCheckedKeys = itemList.map(i => (
          {
            financialBrandID: i.financialBrandID,
            itemTypeID: i.itemTypeID,
          }
        ))
        this.defaultDisabledKeys = [...this.defaultCheckedKeys]
        const result = await $table.addProductToOrder(itemList)
        if (result) $table.tableLoading = false
      })
    },
    // 获取自定义列详情
    getCustomColumn() {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColumnByFuncCode.html', this.Qs.stringify({ funcCode: 208 }))
        $table.tableLoading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let tempArr = JSON.parse(res.result)
        this.hideColumnList = this.hideColumnList.map(i => {
          tempArr.forEach(j => {
            if (i.prop == j.prop) {
              i['isShow'] = j.isShow
              i['id'] = j.id
            }
          })
          return i
        })
      })
    }
  }
};
</script>
<style lang="less" src="./assets/css/ys-page.less"></style>
<style scoped lang="less">
#tab {
  .el-aside {
    .box-card {
      height: calc(100% - 2px);
      ::v-deep .el-card__header {
        padding: 8px 20px;
        height: 33px;
      }
      ::v-deep .el-card__body {
        padding: 0;
        height: calc(100% - 33px);
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
  }
  .el-main {
    padding: 0 0 0 6px;

    .el-tabs {
      height: calc(100% - 2px);
      box-shadow: none;
      ::v-deep .el-tabs__header {
        height: 0;
        .el-tabs__nav-wrap, .el-tabs__nav {
          height: 0;
        }
      }
      ::v-deep .el-tabs__item {
        height: 0;
      }

      ::v-deep .el-tabs__content {
        height: calc(100% - 24px);
        padding: 12px;

        .el-tab-pane {
          height: 100%;

          .el-card {
            border: none;
            .el-card__body {
              padding: 0 0 12px 0;
            }
          }
        }
      }
    }
  }
}

</style>